
import _ from 'underscore'

import { ApiModule } from '@api/src/ApiModule'
// import { Request } from '@api/modules/Request'

// const Ambition = window.Ambition

export class Application extends ApiModule {

  constructor(props) {
    super(props)

    this.data = {}

    this.get = this.read

    // this.loadData()
  }

  async loadData() {
    if (!window.Ambition) return
    const response = await window.Ambition.Request.call({})
    //
    const data = response.data
    if (typeof data === 'object') this.data = data
  }

  create() { }

  /**
   * Read the whole saved data object or just specific properties by key
   *
   * i.e
   *    a = { a:1, b:2, c:{ x: 345, b: ['A', 'B'] } }
   *    _.property('c.x')(a) => 345
   *    _.property('c.b[1]')(a) => B
   *
   * @param {*} prop_key
   */
  read(prop_key = false) {
    // Return all data if prop key is not passed, or return specific value
    if (!prop_key) return this.data
    // Key should be dot notation for nested props i.e. prop_key = 'applicants'
    else return _.property(prop_key)(this.data)
  }

  update() { }

  delete() { }
}
